import React from 'react';
import { Save } from 'lucide-react';
import { useWorkspace } from '../contexts/WorkspaceContext';
import { SubRegionManager } from '../components/SubRegionManager';
import { ContactCategoryManager } from '../components/ContactCategoryManager';
export function Settings() {
  const {
    currentWorkspace
  } = useWorkspace();
  return <div className="space-y-6" data-id="element-1704">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-1705">
        <div className="min-w-0" data-id="element-1706">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1707">
            Team Settings
          </h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-1708">
            Configure workspace defaults and branding for{' '}
            {currentWorkspace.name}.
          </p>
        </div>
        <button className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 whitespace-nowrap flex-shrink-0" data-id="element-1709">
          <Save className="h-4 w-4 flex-shrink-0" data-id="element-1710" />
          <span data-id="element-1711">Save Changes</span>
        </button>
      </div>

      <div className="space-y-6 max-w-4xl" data-id="element-1712">
        {/* Branding Section */}
        <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 sm:p-6 space-y-4" data-id="element-1713">
          <h3 className="text-lg font-medium text-gray-900" data-id="element-1714">Branding</h3>
          <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" data-id="element-1715">
            <div className="sm:col-span-4" data-id="element-1716">
              <label className="block text-sm font-medium text-gray-700" data-id="element-1717">
                Team Name
              </label>
              <input type="text" defaultValue={currentWorkspace.name} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" data-id="element-1718" />
            </div>
            <div className="sm:col-span-6" data-id="element-1719">
              <label className="block text-sm font-medium text-gray-700" data-id="element-1720">
                Logo URL
              </label>
              <input type="url" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" placeholder="https://..." data-id="element-1721" />
            </div>
            <div className="sm:col-span-3" data-id="element-1722">
              <label className="block text-sm font-medium text-gray-700" data-id="element-1723">
                Primary Color
              </label>
              <div className="mt-1 flex items-center gap-2" data-id="element-1724">
                <input type="color" className="h-8 w-8 rounded border border-gray-300 flex-shrink-0" defaultValue="#2563eb" data-id="element-1725" />
                <span className="text-sm text-gray-500" data-id="element-1726">#2563eb</span>
              </div>
            </div>
          </div>
        </div>

        {/* Sub-Regions Management */}
        <SubRegionManager data-id="element-1727" />

        {/* Contact Categories Management */}
        <ContactCategoryManager data-id="element-1728" />

        {/* Email Defaults */}
        <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 sm:p-6 space-y-4" data-id="element-1729">
          <h3 className="text-lg font-medium text-gray-900" data-id="element-1730">Email Defaults</h3>
          <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" data-id="element-1731">
            <div className="sm:col-span-3" data-id="element-1732">
              <label className="block text-sm font-medium text-gray-700" data-id="element-1733">
                Sender Name
              </label>
              <input type="text" defaultValue={`The Chosen ${currentWorkspace.region}`} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" data-id="element-1734" />
            </div>
            <div className="sm:col-span-3" data-id="element-1735">
              <label className="block text-sm font-medium text-gray-700" data-id="element-1736">
                Sender Email
              </label>
              <input type="email" defaultValue={`noreply@${currentWorkspace.id}.thechosen.tv`} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" data-id="element-1737" />
            </div>
          </div>
        </div>

        {/* Security */}
        <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 sm:p-6 space-y-4" data-id="element-1738">
          <h3 className="text-lg font-medium text-gray-900" data-id="element-1739">Security</h3>
          <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" data-id="element-1740">
            <div className="sm:col-span-3" data-id="element-1741">
              <label className="block text-sm font-medium text-gray-700" data-id="element-1742">
                Opt-in Token Expiry (Hours)
              </label>
              <input type="number" defaultValue="48" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" data-id="element-1743" />
            </div>
            <div className="sm:col-span-6" data-id="element-1744">
              <label className="block text-sm font-medium text-gray-700" data-id="element-1745">
                Global Allowed Domains
              </label>
              <textarea rows={3} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" defaultValue="thechosen.tv" data-id="element-1746" />
            </div>
          </div>
        </div>
      </div>
    </div>;
}